export default (api) => ({
  fetch: (params) => api.$get("/telemetry", { params }),

  fetchByAgency: (agencyId, params) => api.$get(`/agencies/${agencyId}/telemetry`, { params }),

  preparecsv: (agencyId, params) =>
    api.$get(`/agencies/${agencyId}/telemetry/preparecsv`, { params }),
});
